import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';
import PropTypes from 'prop-types';
import { AnalyticsContext } from 'contexts/AnalyticsContext';
import { useContext, useState, useEffect } from 'react';
import { Title, Label } from '../Banners.styled';
import { getColorFont, getFontFamily } from '../utils';
import Banner, { PROMO_SOLDOUT } from '../../Components/Banner';

const BannerDisabledOffers = ({ title, description }) => {
  const [close, setClose] = useState(false);

  const { isMobile } = useContext(CruiseSelectionContext);

  const { utagBannerLoad, constants } = useContext(AnalyticsContext);
  const { TYPES_BANNER } = constants;

  useEffect(() => {
    if (!close) utagBannerLoad(TYPES_BANNER.SOLD_OUT);
  }, [TYPES_BANNER, utagBannerLoad, close, promotions]);

  if (close) return null;

  return (
    <Banner
      onClose={() => {
        setClose(true);
      }}
      type={PROMO_SOLDOUT}
      titleBanner={
        <Title $color={getColorFont(isMobile, PROMO_SOLDOUT)} $fontFamily={getFontFamily(isMobile)}>{title}</Title>
      }
      contentBanner={<Label $weight="400">{description}</Label>}
    />
  );
};

BannerDisabledOffers.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default BannerDisabledOffers;
